module.exports = __webpack_public_path__ + "img/4_icn_bg.3e5bf9fe.png";